var map = {
	"./perm/perm1.webp": 9137,
	"./perm/perm10.png": 7062,
	"./perm/perm2.webp": 8500,
	"./perm/perm3.webp": 2199,
	"./perm/perm4.png": 4513,
	"./perm/perm5.webp": 4581,
	"./perm/perm6.webp": 5800,
	"./perm/perm7.webp": 2059,
	"./perm/perm8.webp": 3886,
	"./perm/perm9.webp": 1673,
	"./samara/samara1.webp": 2667,
	"./samara/samara10.webp": 9693,
	"./samara/samara11.webp": 7778,
	"./samara/samara12.png": 4050,
	"./samara/samara2.webp": 250,
	"./samara/samara3.webp": 7781,
	"./samara/samara4.webp": 1700,
	"./samara/samara5.webp": 5879,
	"./samara/samara6.webp": 7190,
	"./samara/samara7.webp": 3297,
	"./samara/samara8.webp": 7104,
	"./samara/samara9.webp": 6499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6265;